const FREE_GIFT_RULES = [
  { variantId: 45582467793058, minAmount: 499 },
  { variantId: 45805238386850, minAmount: 1199 }
];

// const SPECIAL_GIFT_ID = 45885044129954;   // draft product id
 const SPECIAL_GIFT_ID = 45747571130530;  // after bite
const SPECIAL_GIFT_ID_NEW = 47505504043170;  // Free Simply Unscented Baby Bathing Bar - Unscented Soap
const SPECIAL_GIFT_NEW_THRESHOLD = 10;
const BLOCKING_PRODUCTS = [42292249198754, 45208160043170, 44071033340066];

const GIFT_1499_ID = 41120619004066;
const THRESHOLD_1499 = 1499;
const ADJUSTMENT_PRODUCTS = [
  { variantId: 45450084614306, deductAmount: 1196 },
  { variantId: 45450084647074, deductAmount: 897 },
  { variantId: 45450084679842, deductAmount: 598 },
  { variantId: 45450084712610, deductAmount: 299 }
];

const REMOVE_FREE_PRODUCT_ID = 45892881416354;  // free mini wipes id

// Every product ID that represents a free/gift item — used to cap
// quantity at 1 so none of these can be bumped up via the normal
// quantity stepper like a paid line item can.
const FREE_PRODUCT_IDS = [
  ...FREE_GIFT_RULES.map(r => r.variantId),
  SPECIAL_GIFT_ID_NEW,
  GIFT_1499_ID,
  REMOVE_FREE_PRODUCT_ID,
  SPECIAL_GIFT_ID
];

let isUpdatingGifts = false;

// In-memory cache for product tag lookups during the session
const PRODUCT_TAG_CACHE = {};

// Variant IDs that have failed to add (draft/unpublished/sold out/deleted).
// Once we learn one is unavailable we stop retrying it every sync pass —
// otherwise a single draft gift product causes a failed batch call + a full
// per-item retry loop on EVERY cart interaction, not just once.
const UNAVAILABLE_VARIANTS = new Set();

// Shared timeout so a slow/hanging request can never leave sync stuck.
const AJAX_TIMEOUT_MS = 8000;

// =========================================================================
// Checkout lock
// =========================================================================
function toggleCheckoutButtons(disable) {
  const selectors = [
    '.gokwik-checkout',
    '[name="checkout"]',
    'a[href="/checkout"]',
    'form[action="/cart"] [type="submit"]',
    '.cart__checkout-button'
  ];

  const buttons = document.querySelectorAll(selectors.join(','));
  buttons.forEach(btn => {
    if (disable) {
      btn.setAttribute('data-disabled-by-sync', 'true');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';
    } else {
      btn.removeAttribute('data-disabled-by-sync');
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    }
  });
}

// =========================================================================
// Tag lookup (used by the remove-free-product rule)
// =========================================================================
async function checkHasRemoveFreeTag(cartItems) {
  const fetchPromises = cartItems.map(async item => {
    if (!item.handle) return false;

    if (PRODUCT_TAG_CACHE[item.handle] !== undefined) {
      return PRODUCT_TAG_CACHE[item.handle];
    }

    try {
      const res = await fetch(`/products/${item.handle}.js`);
      const product = await res.json();
      const hasTag = Boolean(product.tags && product.tags.includes('remove_free_99'));
      PRODUCT_TAG_CACHE[item.handle] = hasTag;
      return hasTag;
    } catch {
      PRODUCT_TAG_CACHE[item.handle] = false;
      return false;
    }
  });

  const results = await Promise.all(fetchPromises);
  return results.some(Boolean);
}

// =========================================================================
// Individual rule functions.
// Each one is independent: it only reads `cart` and only writes into its
// OWN keys of `updates`. None of them call each other or share state, so a
// bug or a bad product ID in one rule can't reach into another rule's logic.
// =========================================================================

// Rule: tiered gifts at 499 / 1199
function ruleTieredGifts(cart, totalCartAmount, updates) {
  for (const rule of FREE_GIFT_RULES) {
    const hasGift = cart.items.some(item => item.id == rule.variantId);
    const qualifies = totalCartAmount > rule.minAmount;
    if (qualifies && !hasGift) updates[rule.variantId] = 1;
    if (!qualifies && hasGift) updates[rule.variantId] = 0;
  }
}

// Rule: special gift, cart total > 299, blocked by BLOCKING_PRODUCTS
function ruleSpecialGift(cart, totalCartAmount, updates) {
  const hasSpecialGift = cart.items.some(item => item.id == SPECIAL_GIFT_ID);
  const hasBlockingProduct = cart.items.some(item => BLOCKING_PRODUCTS.includes(item.id));

  if (totalCartAmount > 299 && !hasBlockingProduct && !hasSpecialGift) {
    updates[SPECIAL_GIFT_ID] = 1;
  } else if (hasSpecialGift && (totalCartAmount <= 299 || hasBlockingProduct)) {
    updates[SPECIAL_GIFT_ID] = 0;
  }
}

// Rule: new special gift, cart total > 10, unconditional
function ruleSpecialGiftNew(cart, totalCartAmount, updates) {
  const hasNewSpecialGift = cart.items.some(item => item.id == SPECIAL_GIFT_ID_NEW);

  if (totalCartAmount > SPECIAL_GIFT_NEW_THRESHOLD && !hasNewSpecialGift) {
    updates[SPECIAL_GIFT_ID_NEW] = 1;
  } else if (totalCartAmount <= SPECIAL_GIFT_NEW_THRESHOLD && hasNewSpecialGift) {
    updates[SPECIAL_GIFT_ID_NEW] = 0;
  }
}

// Rule: 1499 gift, with multi-variant adjustment deduction scaled by quantity
function rule1499Gift(cart, totalCartAmount, updates) {
  const deductAmount = ADJUSTMENT_PRODUCTS.reduce((sum, adj) => {
    const item = cart.items.find(i => i.id == adj.variantId);
    return sum + (item ? item.quantity * adj.deductAmount : 0);
  }, 0);

  const effectiveTotal = totalCartAmount - deductAmount;
  const has1499Gift = cart.items.some(item => item.id == GIFT_1499_ID);

  if (effectiveTotal > THRESHOLD_1499 && !has1499Gift) {
    updates[GIFT_1499_ID] = 1;
  } else if (effectiveTotal <= THRESHOLD_1499 && has1499Gift) {
    updates[GIFT_1499_ID] = 0;
  }
}

// Rule: free product excluded by "remove_free_99" tag or zero-price cart
async function ruleRemoveFreeProduct(cart, updates) {
  const hasFreeProduct = cart.items.some(item => item.id == REMOVE_FREE_PRODUCT_ID);
  const hasProductPrice = cart.items.some(item => item.final_price > 1);
  const hasRemoveFreeTag = await checkHasRemoveFreeTag(cart.items);

  if (!hasRemoveFreeTag && !hasFreeProduct && hasProductPrice) {
    updates[REMOVE_FREE_PRODUCT_ID] = 1;
  } else if (hasFreeProduct && (hasRemoveFreeTag || !hasProductPrice)) {
    updates[REMOVE_FREE_PRODUCT_ID] = 0;
  }
}

// Rule: cap every free/gift product's quantity at 1. Runs last so it can see
// what every other rule already decided — it never overrides a pending
// removal (updates[id] === 0), it only fills in gaps other rules left alone.
function ruleCapFreeGiftQuantities(cart, updates) {
  for (const item of cart.items) {
    if (FREE_PRODUCT_IDS.includes(item.id) && item.quantity > 1 && updates[item.id] === undefined) {
      console.log('test');
      updates[item.id] = 1;
    }
  }
}

// =========================================================================
// Orchestrator — runs every rule, collects everything into one `updates`
// object, then applies it as a single batch call (with a per-item fallback
// if the batch fails, e.g. because one gift product is draft/unavailable).
// =========================================================================
async function syncAllGifts() {
  if (isUpdatingGifts) return;

  isUpdatingGifts = true;
  toggleCheckoutButtons(true);

  const cartDrawer = document.querySelector('cart-drawer.drawer');
  const mainCart = document.querySelector('#main-cart-items');

  try {
    let cart;
    try {
      cart = await fetch('/cart.js').then(r => r.json());
    } catch (err) {
      console.error('Error fetching cart:', err);
      return; // handled by finally below
    }

    const updates = {};
    const totalCartAmount = cart.total_price / 100;

    ruleTieredGifts(cart, totalCartAmount, updates);
    ruleSpecialGift(cart, totalCartAmount, updates);
    ruleSpecialGiftNew(cart, totalCartAmount, updates);
    rule1499Gift(cart, totalCartAmount, updates);
    await ruleRemoveFreeProduct(cart, updates);
    ruleCapFreeGiftQuantities(cart, updates);

    // Don't re-attempt adding a variant we already know is unavailable this
    // session. Removals (quantity 0) are always allowed through.
    for (const variantId of Object.keys(updates)) {
      if (updates[variantId] > 0 && UNAVAILABLE_VARIANTS.has(String(variantId))) {
        delete updates[variantId];
      }
    }

    if (Object.keys(updates).length === 0) {
      return; // nothing to change — finally still cleans up locks/loading
    }

    if (cartDrawer) $(cartDrawer).addClass('loading');
    if (mainCart) mainCart.classList.add('loading');

    try {
      await new Promise((resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: { updates: updates },
          dataType: 'json',
          timeout: AJAX_TIMEOUT_MS,
          success: resolve,
          error: reject
        });
      });
    } catch (batchErr) {
      // /cart/update.js applies the whole batch atomically — if ANY variant
      // in it is unavailable (draft/unpublished, sold out, deleted), the
      // entire request is rejected and NONE of the updates apply. Fall back
      // to applying each update individually so one bad ID can't block the
      // rest.
      console.warn('Batch cart update failed — retrying updates individually to isolate the problem variant.', batchErr);

      for (const [variantId, qty] of Object.entries(updates)) {
        try {
          await new Promise((resolve, reject) => {
            $.ajax({
              type: 'POST',
              // change.js can only alter a line that's ALREADY in the cart —
              // it cannot add a new item. Adding requires add.js; only
              // removing (qty 0) an existing line should go through change.js.
              url: qty > 0 ? '/cart/add.js' : '/cart/change.js',
              data: qty > 0
                ? { id: variantId, quantity: qty }
                : { id: variantId, quantity: 0 },
              dataType: 'json',
              timeout: AJAX_TIMEOUT_MS,
              success: resolve,
              error: reject
            });
          });
        } catch (itemErr) {
          console.error(`Skipping variant ${variantId} — likely unavailable (draft/sold out/deleted).`, itemErr);
          if (qty > 0) {
            UNAVAILABLE_VARIANTS.add(String(variantId));
          }
        }
      }
    }

    // Wait for the DOM refresh to actually finish before unlocking
    await new Promise(resolve => {
      if (window.location.pathname === '/cart') {
        updateCartPageAjax(resolve);
      } else {
        refreshCartDrawer(resolve);
      }
    });
  } catch (err) {
    // Catch-all: if anything above throws unexpectedly, this still runs the
    // finally block below instead of leaving checkout/loading stuck forever.
    console.error('Cart gift sync failed unexpectedly:', err);
  } finally {
    if (mainCart) mainCart.classList.remove('loading');
    if (cartDrawer) $(cartDrawer).removeClass('loading');
    isUpdatingGifts = false;
    toggleCheckoutButtons(false);
  }
}

// =========================================================================
// UI replacement logic
// =========================================================================
function updateCartPageAjax(callback) {
  $.get(location.href, function (html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const selectors = [
      '#main-cart-items', '#main-cart-footer', '.cart__footer',
      '#cart-icon-bubble', '.cart-count-bubble', '#CartCount', '.cart-count'
    ];

    selectors.forEach(selector => {
      const newEl = doc.querySelector(selector);
      const currentEl = document.querySelector(selector);
      if (newEl && currentEl) {
        currentEl.innerHTML = newEl.innerHTML;
        currentEl.className = newEl.className;
      }
    });
  }).always(function () {
    const mainCart = document.querySelector('#main-cart-items');
    if (mainCart) mainCart.classList.remove('loading');
    if (callback) callback();
  });
}

function refreshCartDrawer(callback) {
  $.get(location.href, function (html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartDrawer = doc.querySelector('cart-drawer.drawer');
    const cartDrawer = document.querySelector('cart-drawer.drawer');

    if (newCartDrawer && cartDrawer) {
      const classesToKeep = ['active', 'is-open', 'open', 'opened', 'transition', 'loading'];
      const keptClasses = classesToKeep.filter(cls => cartDrawer.classList.contains(cls));
      cartDrawer.className = newCartDrawer.className;
      keptClasses.forEach(cls => cartDrawer.classList.add(cls));
    }

    const newInner = doc.querySelector('#CartDrawer');
    const currentInner = document.querySelector('#CartDrawer');
    if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;

    ['#cart-icon-bubble', '.cart-count-bubble', '#CartCount', '.cart-count'].forEach(sel => {
      const newEl = doc.querySelector(sel);
      const currentEl = document.querySelector(sel);
      if (newEl && currentEl) {
        currentEl.innerHTML = newEl.innerHTML;
        currentEl.className = newEl.className;
      }
    });
  }).always(function () {
    const cd = document.querySelector('cart-drawer.drawer');
    if (cd) $(cd).removeClass('loading');
    if (callback) callback();
  });
}

// =========================================================================
// Entry points
// =========================================================================
let syncDebounceTimer = null;
function update_cart_page() {
  clearTimeout(syncDebounceTimer);
  syncDebounceTimer = setTimeout(() => syncAllGifts(), 50);
}

document.addEventListener('click', function (e) {
  const checkoutBtn = e.target.closest('.gokwik-checkout, [name="checkout"], a[href="/checkout"], .cart__checkout-button');

  if (checkoutBtn && isUpdatingGifts) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  if (e.target.closest('.quantity__button') || e.target.closest('.cart-remove-button') || e.target.closest('cart-remove-button')) {
    toggleCheckoutButtons(true);
    update_cart_page();
  }
}, true);

document.addEventListener('change', function (e) {
  if (e.target.closest('.quantity__input')) {
    toggleCheckoutButtons(true);
    update_cart_page();
  }
});

const CART_ENDPOINTS = ['/cart/change.js', '/cart/update.js', '/cart/add.js', '/cart/add', '/cart/change', '/cart/update'];
const originalFetch = window.fetch;

window.fetch = function (...args) {
  const requestUrl = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
  const isCartCall = CART_ENDPOINTS.some(endpoint => requestUrl.includes(endpoint));

  return originalFetch.apply(this, args).then(response => {
    if (isCartCall && !isUpdatingGifts) {
      update_cart_page();
    }
    return response;
  });
};
 
document.addEventListener('DOMContentLoaded', syncAllGifts);